import { useCallback, useEffect, useState } from "react";
import useApplicationSettings from "../../Store/ApplicationSettings";
import { useNotificationStore } from "../../Store/NotificationStore";
import { useNavigate } from "react-router-dom";
import banner from "/videomakerposter_11zon.webp";
import styles from "./CreateContentPage.module.css";
import { sendContentLink } from "../../Services/Requests";
const CreateContentPage = () => {
  const tg = window.Telegram.WebApp;
  const navigate = useNavigate();
  const { setShowMenubar } = useApplicationSettings((state) => ({
    setShowMenubar: state.setShowMenubar,
  }));
  const setNotification = useNotificationStore(
    (state) => state.setNotification
  );
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState("");

  const handleSendLink = useCallback(async () => {
    if (isLoading) return;
    if (!value.trim()) {
      setNotification({
        message: "Пожалуйста, введи ссылку",
        type: "Error",
      });
      return;
    }
    try {
      setIsLoading(true);
      tg.MainButton.showProgress(true);
      const response = await sendContentLink(value);
      console.log(response);
      if (response.status_code === 200) {
        console.log(response);
        setValue("");
        setNotification({
          message: "Заявка успешно отправлена",
          type: "Success",
        });
      } else if (
        response.status_code === 403 &&
        response.detail === "You already added this link today"
      ) {
        setNotification({
          message: "Вы уже отправили заявку сегодня.",
          type: "Error",
        });
      } else {
        setNotification({
          message: "Неправильная ссылка",
          type: "Error",
        });
      }
    } catch (e) {
      setNotification({
        message: "Ошибка при отправке ссылки",
        type: "Error",
      });
    } finally {
      tg.MainButton.hideProgress();
      setTimeout(() => {
        setIsLoading(false);
      }, 5000);
    }
  }, [
    value,
    setNotification,
    setValue,
    setIsLoading,
    tg.MainButton,
    isLoading,
  ]);

  const handleBack = useCallback(() => {
    navigate("/profile");
  }, [navigate]);

  useEffect(() => {
    tg.MainButton.show();
    tg.MainButton.setText("Отправить заявку");
    tg.MainButton.setParams({
      color: "#83B63A",
      text_color: "#FFFFFF",
    });
    tg.setBottomBarColor("#1F0234");

    return () => {
      tg.MainButton.hide();
    };
  }, []);

  useEffect(() => {
    if (isLoading) {
      tg.MainButton.disable();
      tg.MainButton.setParams({
        color: "#737373",
        text_color: "#FFFFFF",
      });
    } else {
      tg.MainButton.enable();
      tg.MainButton.setParams({
        color: "#83B63A",
        text_color: "#FFFFFF",
      });
    }
  }, [isLoading]);

  useEffect(() => {
    tg.MainButton.onClick(handleSendLink);
    return () => {
      tg.MainButton.offClick(handleSendLink);
    };
  }, [handleSendLink]);

  useEffect(() => {
    setShowMenubar(false);
    tg.BackButton.show();
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
    };
  }, [handleBack, tg.BackButton, setShowMenubar]);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.headerWrapper}>
          <div className={styles.header}>
            <img src={banner} alt="Main" className={styles.image} />
          </div>
        </div>

        <div className={styles.textContent}>
          <div className={styles.title}>Создавай контент об игре</div>
          <div className={styles.description}>
            Вставляй ссылку на него в поле ниже <br /> и получай награды за
            популяризацию Dreamcoin.
          </div>
        </div>
        <div className={styles.inputContent}>
          <input
            className={styles.inputItself}
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Вставь ссылку"
          />
          <div className={styles.inputSubText}>
            Подробнее о том, что это такое, можно узнать{" "}
            <a
              target="_blank"
              href="https://telegra.ph/Pravila-dlya-populyarizacii-Dreamcoin-03-27"
            >
              здесь
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateContentPage;
